import React from "react";
import { createRoot } from 'react-dom/client';
import ErrorBox from "../../common/ErrorBox";
import { useState, useEffect } from "react";
import { ConfigProvider, Modal, App, Tabs } from 'antd';
import { EditableContextProvider } from "../../common/EditableContextProvider";
import { customTheme } from "../../common/customTheme";
import { useCasos } from "../../admin/casos/useCasos";
import { TableComponent } from "./TableComponent";
/* import { FormComponent } from "./FormComponent";
import { TablePasos } from "./TablePasos";
import { TablePagos } from "./TablePagos"; 
import { DocumentosModal } from "./DocumentosModal";*/
import { ModalPasos } from "./ModalPasos";
import { ModalPagos } from "./ModalPagos";
import { ModalDocumentos } from "./ModalDocumentos";

export default function MainTitular() {
    const context = useCasos();

    useEffect(() => {
        Promise.all([context.casos.fillResources(), context.casos.fillItems()]);
    }, []);

    return (
        <div>
            <EditableContextProvider data={{
                ...context
            }}
            >
                <TableComponent />
                <ModalPasos />
                <ModalPagos />
                <ModalDocumentos />

            </EditableContextProvider>
        </div>
    );
}

let main = document.getElementById('casos-junior-main');
if (main) {
    const root = createRoot(main);
    root.render(
        <React.StrictMode>
            <ErrorBox>
                <ConfigProvider theme={customTheme}>
                    <App>
                        <MainTitular />
                    </App>
                </ConfigProvider>
            </ErrorBox>
        </React.StrictMode>
    );
}
